import PropTypes from 'prop-types';

export const spycraftBaseTypes = {
  id: PropTypes.string.isRequired,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
  published_at: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  image_url: PropTypes.string,
  description: PropTypes.string,
  show: PropTypes.exact({
    id: PropTypes.string,
    title: PropTypes.string,
  }),
  external: PropTypes.bool,
  external_url: PropTypes.string,
  sort_order: PropTypes.number,
  showDescription: PropTypes.bool,
};

const spycraftPodcastTypes = {
  ...spycraftBaseTypes,
  show: spycraftBaseTypes.show.isRequired,
  external: PropTypes.bool.isRequired,
};

export const spycraftBasicType = PropTypes.exact(spycraftBaseTypes);
export const spycraftPodcastType = PropTypes.exact(spycraftPodcastTypes);

export const spycraftPodcastArrType = PropTypes.arrayOf(spycraftPodcastType);
export const spycraftBasicArrType = PropTypes.arrayOf(spycraftBasicType);
export const spycraftMixedArrType = PropTypes.arrayOf(
  PropTypes.oneOfType([spycraftBasicType, spycraftPodcastType]),
);
